import React, { useEffect, Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import * as XLSX from 'xlsx';
import { loadClientsList, clearClient } from '../../../actions/adminAction';

import ClientsList from './ClientsList';

const Clients = () => {
  const dispatch = useDispatch();
  const clientsList = useSelector((state) => state.admin.clientsList);
  const clientListLoading = useSelector(
    (state) => state.admin.clientListLoading,
  );
  const dark = useSelector((state) => state.dark.data);

  useEffect(() => {
    if (clientsList.length === 0 && clientListLoading) {
      dispatch(loadClientsList());
    }
  }, [clientsList, clientListLoading]);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  return (
    <Fragment>
      <div className='px-sm-5  px-2 admin-margin w-100 d-flex flex-column my-4 w-100'>
        <div className='mb-2'>
          <div className='d-flex align-items-center'>
            <h6 className='text-main mb-0'>Admin / Companies</h6>{' '}
            <div className='rounded-pill text-main admin-list-btn-primary admin-list-count px-2 py-1 align-self-center mx-2 my-2 caption '>
              {clientsList.length}
            </div>
          </div>
          <div className='d-flex w-100 align-items-center justify-content-end'>
            <div className='d-flex'>
              <div
                className='btn button-parent admin-list-btn-secondary d-flex align-items-center px-3 text-main'
                onClick={() => {
                  navigate('/admin/clients/add');
                  dispatch(clearClient());
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  enableBackground='new 0 0 24 24'
                  height='18px'
                  viewBox='0 0 24 24'
                  width='24px'
                  fill='#ffffff'
                  className='button-child'
                >
                  <g>
                    <rect fill='none' height='18' width='18' />
                  </g>
                  <g>
                    <g>
                      <path d='M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z' />
                    </g>
                  </g>
                </svg>
                Add Company
              </div>
            </div>
          </div>
        </div>
        <div className='flex-fill'>
          <ClientsList
            clientsList={clientsList}
            clientListLoading={clientListLoading}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Clients;
